// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"15cd7e2a","823":"93d9ae59"}[chunkId] + ".chunk.js";
};